import React from 'react'
import {
  Box,
  Typography,
  Paper,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Switch,
  Button
} from '@mui/material'
import {
  Settings,
  Notifications,
  People,
  Security,
  Email,
  Storage,
  Backup
} from '@mui/icons-material'

import RoleGuard from '../../components/Auth/RoleGuard'

const SettingsPage = () => {
  const settingsSections = [
    {
      title: 'Notificaciones',
      icon: <Notifications />,
      items: [
        { label: 'Recordatorios semanales', enabled: true },
        { label: 'Alertas de facturas vencidas', enabled: false },
        { label: 'Resúmenes mensuales', enabled: true }
      ]
    },
    {
      title: 'Usuarios',
      icon: <People />,
      items: [
        { label: 'Gestión de usuarios', action: 'manage' },
        { label: 'Roles y permisos', action: 'configure' },
        { label: 'Sesiones activas', action: 'view' }
      ]
    },
    {
      title: 'Sistema',
      icon: <Storage />,
      items: [
        { label: 'Configuración de S3', action: 'configure' },
        { label: 'Base de datos', action: 'manage' },
        { label: 'Logs del sistema', action: 'view' }
      ]
    }
  ]

  return (
    <RoleGuard requireAdmin redirectTo404>
      <Box>
        {/* Page Header */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="h4" fontWeight={700} gutterBottom>
            Configuración
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Administra la configuración del sistema y usuarios
          </Typography>
        </Box>

        {/* Settings Sections */}
        <Grid container spacing={3} sx={{ mb: 4 }}>
          {settingsSections.map((section, index) => (
            <Grid item xs={12} md={6} lg={4} key={index}>
              <Card sx={{ height: '100%' }}>
                <CardHeader
                  avatar={
                    <Box
                      sx={{
                        p: 1,
                        borderRadius: 2,
                        backgroundColor: 'primary.main',
                        color: 'white',
                        display: 'flex'
                      }}
                    >
                      {section.icon}
                    </Box>
                  }
                  title={section.title}
                  titleTypographyProps={{ fontWeight: 600 }}
                />
                <Divider />
                <CardContent sx={{ p: 0 }}>
                  <List>
                    {section.items.map((item, itemIndex) => (
                      <ListItem 
                        key={itemIndex}
                        secondaryAction={
                          item.enabled !== undefined ? (
                            <Switch
                              checked={item.enabled}
                              color="primary"
                            />
                          ) : (
                            <Button size="small" variant="outlined">
                              {item.action === 'manage' ? 'Gestionar' :
                               item.action === 'configure' ? 'Configurar' : 'Ver'}
                            </Button>
                          )
                        }
                      >
                        <ListItemText primary={item.label} />
                      </ListItem>
                    ))}
                  </List>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* System Info */}
        <Paper sx={{ p: 3 }}>
          <Typography variant="h6" fontWeight={600} gutterBottom>
            Información del Sistema
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
              <Typography variant="body2" color="text.secondary">
                Versión
              </Typography>
              <Typography variant="body1" fontWeight={500}>
                v1.0.0
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Typography variant="body2" color="text.secondary">
                Última actualización
              </Typography>
              <Typography variant="body1" fontWeight={500}>
                17 Sep 2024
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Typography variant="body2" color="text.secondary">
                Estado del servidor
              </Typography>
              <Typography variant="body1" fontWeight={500} color="success.main">
                Operativo
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Typography variant="body2" color="text.secondary">
                Base de datos
              </Typography>
              <Typography variant="body1" fontWeight={500} color="success.main">
                Conectada
              </Typography>
            </Grid>
          </Grid>
        </Paper>
      </Box>
    </RoleGuard>
  )
}

export default SettingsPage
